// i18n.ts
export const locales = ["pt-BR", "pt-PT", "en-US"] as const;
export const defaultLocale = "pt-BR";

export type Locale = (typeof locales)[number];
